import { jsx, jsxs } from "react/jsx-runtime";
import * as React from "react";
import { forwardRef } from "react";
const SvgWarningIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ jsxs("svg", { width: 125, height: 125, viewBox: "0 0 125 125", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props, children: [
  title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
  /* @__PURE__ */ jsx("circle", { cx: 62.5, cy: 62.5, r: 62.5, fill: "#F5E1E9" }),
  /* @__PURE__ */ jsxs("g", { opacity: 0.1, children: [
    /* @__PURE__ */ jsx("path", { d: "M121.523 42.8125C120.443 42.9796 119.336 43.0664 118.209 43.0664C106.335 43.0664 96.7088 33.4405 96.7088 21.5664C96.7088 18.1296 97.5152 14.8812 98.949 12C109.376 19.5893 117.366 30.3253 121.523 42.8125Z", fill: "#9D4C6C" }),
    /* @__PURE__ */ jsx("path", { d: "M58.4302 124.954C59.2653 121.63 59.7088 118.15 59.7088 114.566C59.7088 91.0943 40.6809 72.0664 17.2088 72.0664C11.469 72.0664 5.99501 73.2042 1 75.2666C6.62121 102.499 29.9592 123.256 58.4302 124.954Z", fill: "#9D4C6C" })
  ] }),
  /* @__PURE__ */ jsx("path", { d: "M62.7143 87.1431C59.9923 87.1431 57.7857 89.3497 57.7857 92.0716C57.7857 94.7936 59.9923 97.0002 62.7143 97.0002C65.4363 97.0002 67.6428 94.7936 67.6428 92.0716C67.6428 89.3497 65.4363 87.1431 62.7143 87.1431Z", fill: "#9D4C6C" }),
  /* @__PURE__ */ jsx("rect", { x: 58, y: 28, width: 10, height: 49, rx: 5, fill: "#9D4C6C" })
] });
const ForwardRef = forwardRef(SvgWarningIcon);
export default ForwardRef;
